export function showConfirm(hint, action, that) {
  return that.$confirm(`此操作将永久删除该${hint}, 是否继续?`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => action().then((res) => {
      console.log('action', res);
      that.$message({
        type: 'success',
        message: '删除成功!',
      });
      return Promise.resolve();
    }))
    .catch(() => {
      that.$message({
        type: 'info',
        message: '已取消删除',
      });
      return Promise.reject();
    });
}
export function showMessage() {

}
